// 七牛云-华北区
const upload_url = '/admin/AliOss/index';

// 请求地址
const admin_api = '/admin';

//定义全局变量
const api_url = '';
const token = '';
const user_name = '';
const user_id = 0;
export default {
    upload_url,
    admin_api,
    api_url,
    token,
    user_name,
    user_id
}



// WEBPACK FOOTER //
// ./src/util/common.js